/** @jsxImportSource @emotion/react */

import React from 'react';
import Subscription from '@component/iyagigo/hub/subscription';
import PageTemplate from '@page/iyagigo/page-template';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { useNavigate } from 'react-router-dom';

const SubscriptionPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageTemplate
      title='구독'
      mode={'back'}
      handleNavigationClick={() => navigate(IYAGIGO_PATH.HUB_HOME_PATH)}>
      <Subscription />
    </PageTemplate>
  );
};

export default SubscriptionPage;
